var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBumpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7483,
    cy: 10.805,
    r: 10.4768,
    fill: "#3653B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5579 10.0006L10.7487 4.19141L4.93945 10.0006L6.53536 11.5965L10.748 7.38401L10.7487 7.3833L14.962 11.5965L16.5579 10.0006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5579 14.1998L10.7487 8.39062L10.748 8.39125L4.93945 14.1998L6.53536 15.7957L10.748 11.5831L10.7487 11.5825L14.962 15.7957L16.5579 14.1998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9621 11.5965L16.558 10.0006L10.7488 4.19141L10.748 4.19212V7.38401L10.7488 7.3833L14.9621 11.5965Z",
    fill: "#ADFFF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7488 8.38867L10.748 8.38929V11.5812L10.7488 11.5806L14.9621 15.7938L16.558 14.1979L10.7488 8.38867Z",
    fill: "#ADFFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBumpIcon);
export default __webpack_public_path__ + "static/media/bump_icon.f449b8de1b89498675871031fb157f16.svg";
export { ForwardRef as ReactComponent };